var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
export function HearingTestResult() {
    var birthYear = useSelector(function (state) { var _a; return (_a = state.wizard.form) === null || _a === void 0 ? void 0 : _a['birth-year']; });
    var averageSnr = useSelector(function (state) { return state.dinTest.result.averageSnr; });
    return (_jsxs("div", __assign({ className: "flex flex-col gap-4 md:flex-row md:gap-32" }, { children: [_jsxs(Typography, __assign({ variant: "h5", className: "font-normal text-xl" }, { children: ["Ann\u00E9e de naissance: ", birthYear === null || birthYear === void 0 ? void 0 : birthYear.toString()] })), _jsxs(Typography, __assign({ variant: "h5", className: "font-normal text-xl" }, { children: ["RSB: ", averageSnr === null || averageSnr === void 0 ? void 0 : averageSnr.toFixed(2), " dB"] }))] })));
}
